import type { HelpFile } from '../../types/help'
import { AccessProfileDetailTestIds } from '../../../testids/AccessProfileDetailTestIds'

export const accessProfileDetailHelp: HelpFile = {
  docPage: '/docs/access/entitlements',
  texts: {
    [AccessProfileDetailTestIds.accessProfileDetailPage]:
      'Detailansicht eines Zugriffsprofils — seine Durchsetzungsobjekte, Verantwortlichen und die Funktionsgruppen, die es gewähren.',
    [AccessProfileDetailTestIds.apFunctionGroupsCard]:
      'Funktionsgruppen, die direkt diesem Zugriffsprofil zugeordnet sind. Identitäten, die diesen Funktionsgruppen zugewiesen sind, erben dieses Zugriffsprofil.',
    [AccessProfileDetailTestIds.btnActivate]:
      'Aktiviert dieses Zugriffsprofil, sodass es vergeben und auf Konten bereitgestellt werden kann.',
    [AccessProfileDetailTestIds.btnAddEnforcementObject]:
      'Enforcement-Objekt hinzufügen, das dieses Zugriffsprofil auf einem Zielsystem gewährt.',
    [AccessProfileDetailTestIds.btnDeleteProfile]:
      'Zugriffsprofil dauerhaft löschen — bestehende Vergaben werden ungültig.',
    [AccessProfileDetailTestIds.btnDeprecate]:
      'Als veraltet markieren — sperrt neue Anfragen, erhält aber bestehende Vergaben.',
    [AccessProfileDetailTestIds.btnEdit]: null,
    [AccessProfileDetailTestIds.btnRetryFg]:
      'Funktionsgruppen nach einem temporären Fehler erneut laden.',
    [AccessProfileDetailTestIds.btnSelectAllEnforcementObjects]:
      'Alle Enforcement-Objekte für eine Sammel-Entfernung auswählen.',
    [AccessProfileDetailTestIds.cardProfileDetails]:
      'Kernattribute des Zugriffsprofils — Name, Code, Beschreibung, Status und Risikometadaten.',
    [AccessProfileDetailTestIds.cardTitleEnforcementObjects]:
      'Durchsetzungsobjekte (Gruppen, Berechtigungen, Rollen auf Zielsystemen), die durch dieses Zugriffsprofil gewährt werden.',
    [AccessProfileDetailTestIds.colActions]: null,
    [AccessProfileDetailTestIds.colEnforcementObject]: null,
    [AccessProfileDetailTestIds.colEoName]:
      'Name des Durchsetzungsobjekts, wie es auf dem Zielsystem erscheint.',
    [AccessProfileDetailTestIds.colEoSystem]:
      'Zielsystem, auf dem das Durchsetzungsobjekt liegt.',
    [AccessProfileDetailTestIds.colEoType]:
      'Typ des Durchsetzungsobjekts — Gruppe, Berechtigung, Rolle oder ein anderer systemspezifischer Typ.',
    [AccessProfileDetailTestIds.colFgName]:
      'Name der Funktionsgruppe, die dieses Zugriffsprofil gewährt.',
    [AccessProfileDetailTestIds.colFgType]:
      'Typ der Funktionsgruppe — zum Beispiel positionsbasiert oder organisationsbasiert.',
    [AccessProfileDetailTestIds.colOperation]:
      'Operation, die beim Bereitstellen des Durchsetzungsobjekts angewendet wird — typischerweise Grant, Revoke oder Sync.',
    [AccessProfileDetailTestIds.colSelect]: null,
    [AccessProfileDetailTestIds.colSystem]:
      'Zielsystem, auf dem das Durchsetzungsobjekt existiert.',
    [AccessProfileDetailTestIds.fgEmptyState]:
      'Diesem Zugriffsprofil sind keine Funktionsgruppen zugeordnet.',
    [AccessProfileDetailTestIds.linkResource]:
      'Ressource-Detailseite des zugehörigen Enforcement-Objekts öffnen.',
    [AccessProfileDetailTestIds.profileCode]:
      'Maschinenlesbarer Code, über den dieses Zugriffsprofil in Regeln und APIs referenziert wird.',
    [AccessProfileDetailTestIds.profileDescription]: null,
    [AccessProfileDetailTestIds.selectOperation]:
      'Provisionierungsoperation für dieses Enforcement-Objekt — Grant, Revoke oder Sync.',
  },
}
